import { hasValue } from "@my-aon/utils";

export interface ITabs {
	tab: string | number;
	icon?: string;
	title: string;
	disabled?: boolean;
	showTitle?: boolean;
}

export class Tabs implements ITabs {
	tab: string | number;
	icon?: string;
	title: string;
	disabled?: boolean;
	showTitle?: boolean = true;

	hasIcon = (): boolean => hasValue(this.icon);

	showIcon = (): boolean => this.hasIcon();

	get iconType(): 'fa' | 'dx' | null {
		if (!this.showIcon()) return null;
		return this.icon?.startsWith('dx') ? 'dx' : 'fa';
	}

	showText = (): boolean => (!!this.showTitle && hasValue(this.title));

	constructor({
		tab, title, icon, disabled, showTitle
	}: {
		tab: string | number,
		title: string,
		icon?: string,
		disabled?: boolean,
		showTitle?: boolean
	}) {
		this.tab = tab;
		this.title = title;
		this.icon = icon;
		this.disabled = disabled ?? false;
		this.showTitle = showTitle ?? true;
	}
}
